import { z } from "zod";
import { localeSchema } from "./locale.ts";
import { roleSchema } from "./role.ts";

export const userSchema = z.object({
  _id: z.string(),
  email: z.string().email(),
  emailVerified: z.boolean().default(false),
  name: z.string().optional(),
  image: z.string().url().optional(),
  locale: localeSchema.default("en"),
  role: roleSchema.default("user"),
  banned: z.boolean().default(false),
  banReason: z.string().optional(),
  banExpires: z.coerce.date().optional(),
  stripeCustomerId: z.string().optional(),
  twoFactorEnabled: z.boolean().default(false),
  lastSeenAt: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().optional(),
});

export type User = z.infer<typeof userSchema>;
